import React from "react";
import { UseFormReturn } from "react-hook-form";

import { Grid, Typography, } from "@mui/material";

import { t, Trans } from "@lingui/macro";

import { ZPlayFormField, ZPlaySelect } from "commons/fields";
import { CURRENCY_CONSTANT, SEGREGATION_TYPE_FORM_CONSTANT, SegregationType } from "commons/form-constants";
import { SegregationSectionProps } from "./models";


export class SegregationSection extends React.Component<SegregationSectionProps & UseFormReturn, {}> {

    render() {
        return (<>
            <Typography
                color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}
                variant="h3"
                textAlign="center"
                mb={3}>
                <Trans id={"df-segregation-section"}>Segregazione</Trans>
            </Typography>

            <Grid>
                <Grid item xs={12} md={4}>
                    <ZPlaySelect
                        name={`${this.props.name}.segregationType`}
                        defaultValue={process.env.REACT_APP_DEFAULT_CONTENT_UPLOAD_SEGREGATION || null}
                        label={t({
                            id: "ss-segregation-type",
                            message: "Tipo di segregazione"
                        })}
                        control={this.props.control}
                        formState={this.props.formState}
                        trigger={this.props.trigger}>
                        {SEGREGATION_TYPE_FORM_CONSTANT.map(
                            (item, index) => (<option value={item.key} key={item.key}>{item.label}</option>))}
                    </ZPlaySelect>
                </Grid>

                {this.props.getValues(`${this.props.name}.segregationType`) === SegregationType.PAY_PER_VIEW &&
                    <Grid container columnSpacing={3} mt={2}>
                        <Grid item xs={12} sm={6} md={6}>
                            <ZPlayFormField
                                label={t({
                                    id: "ss-price",
                                    message: "Prezzo"
                                })}
                                name={`${this.props.name}.price`}
                                control={this.props.control}
                                formState={this.props.formState}
                                trigger={this.props.trigger}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <ZPlaySelect
                                label={t({
                                    id: "ss-currency",
                                    message: "Valuta"
                                })}
                                name={`${this.props.name}.currency`}
                                control={this.props.control}
                                formState={this.props.formState}
                                trigger={this.props.trigger}>
                                {CURRENCY_CONSTANT.map(
                                    (item, index) => (<option value={item.key} key={item.key}>{item.label}</option>))}
                            </ZPlaySelect>
                        </Grid>
                        {this.props.hasAvailabilityDays && <Grid item xs={12} sm={6} md={6}>
                            <ZPlayFormField
                                label={t({
                                    id: "sf-availability-days",
                                    message: "Giorni di disponibilità noleggio"
                                })}
                                name={`${this.props.name}.rentalAvailabilityDays`}
                                control={this.props.control}
                                formState={this.props.formState}
                                trigger={this.props.trigger}
                            />
                        </Grid>}
                    </Grid>}
            </Grid>
        </>)
    }
}